import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { URIOptions, STATES } from 'src/app/models/constdata';
import { Plugin,Customer } from 'src/api/models';
import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { DataBusService, CustomerService } from 'src/api/services';

@Component({
  selector: 'app-databus-purchase',
  templateUrl: './databus-purchase.component.html',
  styleUrls: ['./databus-purchase.component.css']
})
export class DatabusPurchaseComponent implements OnInit {
  public wizardStep = 0;
  public plugins: Plugin[] = [];
  //public customers: Customer[];

  public formModel = {
    uriOption: null,
    //CustomerId: null as Number,
    LicenseName: null,
    Price: null,
    Saved: false,
    OrderId: null,
    SelectedPlugins: [] as Plugin[]
  };

  readonly options = URIOptions;
  public states = STATES;
  public categories: string[] = [];

  constructor(
    private app: ApplicationConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToastrService,
    public dataBusService: DataBusService,
    public customerService: CustomerService,
    public azureAuthService: AzureAuthService) {

    
  }

  ngOnInit(): void {
    // Check if license ID route has been passed, if so fetch existing license information
    this.route.params.subscribe(params => {
      const licenseId = parseInt(params["licenseId"]);
      
      if (!isNaN(licenseId)) {
        // Fetch license
        this.getLicenseById(licenseId);
      }
    });

    this.wizardStep = 0;
    
    if (this.azureAuthService.isAdmin()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => { 
          this.app.customers = c;
        });
      }
    } else {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
      //this.service.get(this.app.customerId);
    }
    
    this.dataBusService.DataBusGetPlugins().subscribe(
      res => {
        let newPlugins = [];
        for (let plugin of res){
          if (plugin.needsLicense == true){
            newPlugins.push(plugin);
            if (plugin.categorys){
              for (let category of plugin.categorys){
                if (!this.categories.includes(category)){
                  this.categories.push(category);
                }
              }
            } else {
              plugin.categorys = ["Other"];
              if (!this.categories.includes("Other")){
                this.categories.push("Other");
              }
            }
          }
        }
        this.categories.sort();
        
        this.plugins = newPlugins;
      }
    );
  }

  getLicenseById(id: number): void {
    this.dataBusService.DataBusGetLicenseById({customerId: this.app.customerId, licenseId: id})
      .subscribe(
        res => {
          console.log(res);
          this.app.customerId = res.customerId;
          this.formModel.OrderId = res.licenseId;
          this.formModel.LicenseName = res.licenseName;
          this.formModel.uriOption = URIOptions.find(option => option.title === res.uriCount.toString());
          this.formModel.SelectedPlugins = res.licensesPlugins.map(pluginName => this.plugins.find(plugin => plugin.typeName === pluginName));
          this.formModel.Price = res.totalPrice;
        },
        err => {
          console.error("ERROR: getLicenseById", err);
          this.toasterService.error("Failed To Find License", "License");
        }
      )
  }

  getName(name){
    return name.replace(/([A-Z])/g, ' $1').trim()
  }

  getRandomString(length: number): string {
    let s = '';
    do {
      s += Math.random().toString(36).substr(2);
    } while (s.length < length);

    s = s.substr(0, length);
    return s;
  }

  doPurchase() {
    this.dataBusService.DataBusCreateOrderForUser(this.formModel.OrderId)
      .subscribe(
        res => {
          this.toasterService.info("Order Created");
          this.router.navigateByUrl('/databus');
        },
        error => {
          console.log(error);
        }
      );
  }

  public doSave(): void {
    if (!this.formModel.LicenseName) {
      this.toasterService.error("License Name Required", "DataBus License")
      return;
    }

    // if an orderId exists, then call update instead of save
    if (this.formModel.OrderId === null) {
      // Save
      this.saveLicense();
    } else {
      // Update
      this.updateLicense();
    }
  }

  public saveLicense() {
    const body: DataBusService.DataBusSaveOrderForUserParams = {
      uriCount: this.formModel.uriOption.input_Items,
      totalPrice: this.formModel.Price,
      licensesPlugins: this.getPluginNames(),
      licenseName: this.formModel.LicenseName,
      customerId: this.app.customerId as number
    };

    this.dataBusService.DataBusSaveOrderForUser(body).subscribe(
      res => {
        this.toasterService.success("Draft Successfully Saved", "DataBus License")
        this.formModel.OrderId = res.licenseId;
        this.formModel.Saved = true;
      },
      error => {
        console.log(error);
      }
    );
  }

  public updateLicense() {
    const body: DataBusService.DataBusUpdateLicenseParams = {
      licenseId: this.formModel.OrderId,
      uriCount: this.formModel.uriOption.input_Items,
      totalPrice: this.formModel.Price,
      licensesPlugins: this.getPluginNames(),
      licenseName: this.formModel.LicenseName
    };

    this.dataBusService.DataBusUpdateLicense(body).subscribe(
      res => {
        this.toasterService.success("Draft Successfully Saved", "DataBus License")
        this.formModel.Saved = true;
      },
      error => {
        console.log(error);
      }
    )
  }

  onSubmit() { }

  selectPlan(item: any) {
    this.formModel.uriOption = item;
    this.setTotal();
  }

  selectOptions(plugin: Plugin) {
    if (this.formModel.SelectedPlugins.includes(plugin)){
      this.removePlugin(plugin);
    } else {
      this.formModel.SelectedPlugins.push(plugin);
    }
    this.setTotal();
  }

  gotoPlugins() {
    this.wizardStep = 1;
  }
  
  gotoLicense() {
    this.wizardStep = 0;
  }

  gotoURICount() {
    this.wizardStep = 0;
  }

  gotoPurchase() {
    if (this.formModel.LicenseName != null && this.formModel.LicenseName.length > 0){
      this.wizardStep = 2;
    }
  }

  setTotal() {
    let p = 0;
    p += this.formModel.uriOption.price;
    for (const pl of this.formModel.SelectedPlugins) {
      p += pl.price;
    }
    this.formModel.Price = p;
  }

  getPluginNames() : string[] {
    let plugins = [];
    for (let pl of this.formModel.SelectedPlugins) {
      //pluginnames += pl.name + ',';
      plugins.push(pl.typeName)
    }
    return plugins;    
  }

  removePlugin(plugin : Plugin) {
    this.formModel.SelectedPlugins.map((item, index) => {
      if (item.typeName === plugin.typeName) {
        this.formModel.SelectedPlugins.splice(index, 1);
      }
    });

    this.setTotal();
  }

  resetURICount() {
    this.formModel.uriOption = null;
    this.formModel.Price = 0;
  }

  removeURICount() {
    this.resetURICount();
    this.setTotal();
    this.wizardStep = 0;
  }
}
